/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrackShipmentResponseDto } from '../../models/track-shipment-response-dto';

export interface BrtControllerTrackShipment$Params {

/**
 * Parcel ID for tracking the shipment
 */
  parcelID: string;
}

export function brtControllerTrackShipment(http: HttpClient, rootUrl: string, params: BrtControllerTrackShipment$Params, context?: HttpContext): Observable<StrictHttpResponse<TrackShipmentResponseDto>> {
  const rb = new RequestBuilder(rootUrl, brtControllerTrackShipment.PATH, 'get');
  if (params) {
    rb.path('parcelID', params.parcelID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TrackShipmentResponseDto>;
    })
  );
}

brtControllerTrackShipment.PATH = '/couriers/brt/track-shipment/{parcelID}';
